import { render, staticRenderFns } from "./BalanceStatement.vue?vue&type=template&id=27071c3b&scoped=true"
import script from "./BalanceStatement.vue?vue&type=script&lang=js"
export * from "./BalanceStatement.vue?vue&type=script&lang=js"
import style0 from "./BalanceStatement.vue?vue&type=style&index=0&id=27071c3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27071c3b",
  null
  
)

export default component.exports